import { render, staticRenderFns } from "./batchAmt.vue?vue&type=template&id=267b64de&scoped=true"
import script from "./batchAmt.vue?vue&type=script&lang=js"
export * from "./batchAmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267b64de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267b64de')) {
      api.createRecord('267b64de', component.options)
    } else {
      api.reload('267b64de', component.options)
    }
    module.hot.accept("./batchAmt.vue?vue&type=template&id=267b64de&scoped=true", function () {
      api.rerender('267b64de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/batchAmt.vue"
export default component.exports